import { fromJS } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { postIndividual } from '@client/connectivity/api.individual';

export const INDIVIDUAL_REDUCER_KEY = 'individualReducer';

export const POST_AND_HANDLE_INDIVIDUAL = 'POST_AND_HANDLE_INDIVIDUAL';
export const SET_INDIVIDUAL_ERROR = 'SET_INDIVIDUAL_ERROR';

let defaultState = fromJS({
  individual: null,
  errors: {
    loadIndividuals: null,
  },
});

export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case POST_AND_HANDLE_INDIVIDUAL: {
      const errors = state.get('errors');
      return state.merge({
        individual: fromJS(action.payload),
        errors: errors.set('loadIndividuals', null),
      });
    }
    case SET_INDIVIDUAL_ERROR: {
      return state.setIn(['errors', 'default'], action.error);
    }
    default:
      return state;
  }
}

export function postAndHandleIndividual(individual) {
  return function(dispatch) {
    return postIndividual(individual).then((response) => {
      return dispatch({
        type: POST_AND_HANDLE_INDIVIDUAL,
        payload: response.data,
      });
    });
  };
}

function setErrorMessage(dispatch, error) {
  return dispatch({
    type: SET_INDIVIDUAL_ERROR,
    payload: error.customMessage,
  });
}

export const selectIndividual = (state) => {
  return getIn(state[INDIVIDUAL_REDUCER_KEY], 'individual');
};
